import Image from 'next/image';

import { sectionTitleClass } from '../shared-styles';

export const OurCultureSection = () => (
  <div
    className="bg-token-gray-100 border-token-gray-300 mx-auto mb-2 flex w-full max-w-[1240px] flex-col items-center justify-center gap-10 overflow-hidden rounded-t-[36px] rounded-b-[8px] border border-solid pt-16 pb-16"
    style={{
      backgroundImage:
        'url("/images/about-us/our-story-background-1.svg"), url("/images/about-us/our-story-background-2.svg")',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'top left, center right',
    }}
  >
    <h1 className={sectionTitleClass}>Our culture</h1>

    <div className="tablet:self-stretch tablet:flex-row tablet:items-end tablet:justify-evenly flex flex-col items-center gap-14 self-stretch">
      <div className="text-token-gray-1000 flex flex-col items-center gap-4 leading-6">
        <Image src="/images/about-us/heart-icon.svg" width={68} height={56} alt="" />
        <span>Do the right thing</span>
      </div>

      <div className="text-token-gray-1000 flex flex-col items-center gap-4 leading-6">
        <Image src="/images/about-us/aim-icon.svg" width={87} height={68} alt="" />
        <span>Consistently ship</span>
      </div>
      <div className="text-token-gray-1000 flex flex-col items-center gap-4 leading-6">
        <Image src="/images/about-us/sun-icon.svg" width={74} height={70} alt="" />
        <span>Create enduring value</span>
      </div>
    </div>
  </div>
);
